import React, { useRef } from "react";
import emailjs from "emailjs-com";
import "./ContattiPage.css";

function ContattiPage() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_mw8a75v",
        "template_h5zzn5d",
        form.current,
        "NdcebfhN7Miiw9FHD"
      )
      .then(
        (result) => {
          alert("Messaggio inviato con successo!");
        },
        (error) => {
          alert("Si è verificato un errore. Riprova più tardi.");
        }
      );

    e.target.reset();
  };

  return (
    <div className="main-content">
      <h1 className="home-title">Contattaci</h1>
      <p className="home-subtitle">
        Hai domande? Compila il modulo e ti risponderemo al più presto!
      </p>
      <form ref={form} className="contact-form" onSubmit={sendEmail}>
        <div className="form-group">
          <label htmlFor="name">Nome</label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Inserisci il tuo nome"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Inserisci la tua email"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="message">Messaggio</label>
          <textarea
            id="message"
            name="message"
            placeholder="Scrivi il tuo messaggio"
            rows="5"
            required
          ></textarea>
        </div>
        <button type="submit" className="btn-submit">
          Invia
        </button>
      </form>
    </div>
  );
}

export default ContattiPage;